import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MensajeForm from "./MensajeForm";
import { getData, pathData } from "../../Utils/Http/api";

const MensajeEdit = () => {
  const { id } = useParams();
  const [valores, setValores] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getData(`/MensajeGet/${id}`);
        setValores({ tipoMensaje: res.value.tipoMensaje, texto: res.value.texto });
      } catch (ex) {
        console.error("Error cargando Mensaje:", ex);
      }
    };
    fetchData();
  }, [id]);

  // El formulario toma los valores iniciales una sola vez, por eso se monta recién
  // cuando el mensaje ya llegó de la API.
  if (!valores) return null;

  return (
    <MensajeForm
      titulo="Editar Mensaje"
      descripcion="Modifica el texto del mensaje seleccionado."
      valoresIniciales={valores}
      onGuardar={(datos) => pathData("/MensajeUpdate", { idMensaje: Number(id), ...datos })}
      mensajeExito="¡Mensaje actualizado exitosamente!"
    />
  );
};

export default MensajeEdit;
